import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";

export default function HotelSlider({ images, children, priority = false }) {
	const CustomNextArrow = ({ onClick }) => (
		<div
			className="absolute right-2 h-fit bg-[#FFFFFF80] rounded-sm p-1 top-1/2 transform -translate-y-1/2 cursor-pointer z-10"
			onClick={(e) => {
				e.stopPropagation();
				onClick(e);
			}}
		>
			<SlArrowRight className="text-[#000]" />
		</div>
	);

	const CustomPrevArrow = ({ onClick }) => (
		<div
			className="absolute left-2 h-fit bg-[#FFFFFF80] rounded-sm p-1 top-1/2 transform -translate-y-1/2 cursor-pointer z-10"
			onClick={(e) => {
				e.stopPropagation();
				onClick(e);
			}}
		>
			<SlArrowLeft className="text-[#000] text-xl" />
		</div>
	);

	const imageSettings = {
		dots: false,
		infinite: true,
		speed: 500,
		slidesToShow: images?.length > 0 ? Math.min(images?.length, 1) : 1,
		slidesToScroll: 1,
		nextArrow: <CustomNextArrow />,
		prevArrow: <CustomPrevArrow />,
	};
	return (
		<>
			{images?.length === 1 ? (
				<div className="w-full relative">
					<img
						src={images[0]}
						alt=""
						loading={priority ? "eager" : "lazy"}
						fetchPriority={priority ? "high" : "auto"}
						decoding={priority ? "sync" : "async"}
						className="w-full h-[260px] object-cover"
					/>
					{children}
					<div className="min-h-[6.4px] w-full"></div>
				</div>
			) : (
				<Slider {...imageSettings}>
					{images?.map((e, imageIndex) => (
						<div key={imageIndex} className="w-full relative">
							<img
								src={e}
								alt=""
								loading={priority && imageIndex === 0 ? "eager" : "lazy"}
								fetchPriority={priority && imageIndex === 0 ? "high" : "auto"}
								decoding={priority && imageIndex === 0 ? "sync" : "async"}
								className="w-full h-[260px] object-cover"
							/>
							{children}
						</div>
					))}
				</Slider>
			)}
		</>
	);
}
